import { onUnmounted } from "vue";

const DEFAULT_REFRESH_TRIGGER = Symbol("refreshTrigger");
export const FILTER_LIST_TRIGGER = Symbol("filterListTrigger");

const callbacks: Record<string, (() => void | Promise<void>)[]> = {};

export function provideRefreshTrigger(onRefresh: () => void | Promise<void>, symbol?: symbol) {
  const key = symbol ?? DEFAULT_REFRESH_TRIGGER;
  const keyStr = key.toString();

  if (!callbacks[keyStr]) {
    callbacks[keyStr] = [];
  }

  if (!callbacks[keyStr].includes(onRefresh)) {
    callbacks[keyStr].push(onRefresh);
  }

  const removeCallback = () => {
    const idx = callbacks[keyStr].indexOf(onRefresh);
    if (idx > -1) {
      callbacks[keyStr].splice(idx, 1);
    }
  };
  onUnmounted(removeCallback);

  function askForRefresh() {
    if (callbacks[keyStr]) {
      callbacks[keyStr].forEach((callback) => {
        Promise.resolve(callback()).catch((err) => console.error("[refreshTrigger] callback error:", err));
      });
    }
  }

  return askForRefresh;
}

export function useRefreshTrigger(symbol?: symbol) {
  const key = symbol ?? DEFAULT_REFRESH_TRIGGER;
  const keyStr = key.toString();

  return function triggerRefresh() {
    if (callbacks[keyStr]) {
      callbacks[keyStr].forEach((callback) => {
        Promise.resolve(callback()).catch((err) => console.error("[refreshTrigger] callback error:", err));
      });
    }
  };
}

export function useAutoRefreshTrigger(intervalMs = 15000, symbol?: symbol) {
  const trigger = useRefreshTrigger(symbol);

  const intervalId = setInterval(() => {
    trigger();
  }, intervalMs);

  onUnmounted(() => {
    clearInterval(intervalId);
  });
}
